import { useCallback, useState } from 'react'
import { useTranslation } from 'next-i18next'

import { ErrorType, NormalizedFetchedData, ServicesSlugsMap } from '../types'
import { fetchData } from '../GetStartedPage.helpers'

type UseFetchData = [
  (slugs: ServicesSlugsMap) => Promise<void>,
  {
    isSuccess: boolean
    isLoading: boolean
    data?: NormalizedFetchedData
    error?: ErrorType
  }
]

export const useFetchData = (): UseFetchData => {
  const { t } = useTranslation(['pages', 'common'])

  const [isLoading, setLoading] = useState(false)
  const [error, setError] = useState<ErrorType>()
  const [isSuccess, setSuccess] = useState(false)
  const [data, setData] = useState<NormalizedFetchedData>()

  const fetchDataWrapper = useCallback(
    async (slugs: ServicesSlugsMap) => {
      try {
        setSuccess(false)
        setLoading(true)
        setError(undefined)

        const data = await fetchData(slugs, t)

        setData(data)
        setSuccess(true)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (e: any) {
        setData(undefined)
        setError(e)
      } finally {
        setLoading(false)
      }
    },
    [t]
  )

  return [fetchDataWrapper, { data, error, isSuccess, isLoading }]
}
